export default __webpack_public_path__ + "static/media/Cisco-Eagle.8f7dd3d2.png";